// src/pages/ForgotPassword.js
import React, { useState } from "react";
import { auth } from "../services/firebase";
import { sendPasswordResetEmail } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { useAlert } from "./AlertContext";
import "./Login.css"; // reuse same styles

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const navigate = useNavigate();
  const showAlert = useAlert();

  const handleReset = async () => {
    if (!email.trim()) {
      showAlert("❗ Please enter your email address.", "warning");
      return;
    }
    try {
      await sendPasswordResetEmail(auth, email);
      showAlert("✅ Reset email sent! Please check your inbox.", "success");
      setTimeout(() => {
        navigate("/login");
      }, 3000);
    } catch (error) {
      showAlert("❌ Error: " + error.message, "error");
    }
  };

  return (
    <div className="login-root">
      <div className="login-left">
        <div className="login-card">
          <div className="login-logo-row">
            <div className="login-logo">BAI</div>
            <span className="login-appname">BodhAI</span>
          </div>
          <h2 className="login-welcome">Forgot Password</h2>
          <p className="login-subtext">Enter your registered email and we'll send you a password reset link.</p>
          <div className="login-input-group">
            <input
              type="email"
              placeholder="Enter your registered email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <div style={{ color: '#b0c4d4', fontSize: '0.93rem', marginTop: '0.3rem' }}>
              Check your spam/junk folder if you don't see the email.
            </div>
          </div>
          <button className="login-btn" onClick={handleReset}>Send Password Reset Link</button>
          <div className="login-bottom-row">
            <a href="/login" className="login-link">← Back to Login</a>
          </div>
        </div>
      </div>
      <div className="login-right">
        <div className="login-showcase-card">
          <h2>Reset & Secure</h2>
          <p>We care about your security. Reset your password and keep your account safe.</p>
          <div className="login-stats-row">
            <div className="login-stat">
              <div className="login-stat-value">100%</div>
              <div className="login-stat-label">Privacy</div>
            </div>
            <div className="login-stat">
              <div className="login-stat-value">24/7</div>
              <div className="login-stat-label">Support</div>
            </div>
            <div className="login-stat">
              <div className="login-stat-value">1M+</div>
              <div className="login-stat-label">Accounts</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
